import React, { useEffect } from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { Input } from 'antd';

import { BASIC_CHART_VIEWS } from '../../../../../constants/event';

const StyledLegendContainer = styled.div`
  display: flex;
  align-items: center;

  .input-caption {
    margin-right: 5px;
    flex-shrink: 0;
  }
`;

const EventLegend = ({ enteredLegendName, onChangeLegendName, unit, events }) => {
  const { view } = unit.compose.events.options;
  const isChartView = BASIC_CHART_VIEWS.includes(view);

  const compareSplits = (event) =>
    _.get(events, '[0].splitColumn', '') === _.get(event, 'splitColumn', '');

  const disableFormula =
    !!events.length && events.some((event) => event.splitColumn && event.othersFilter);

  const isSplitSame = !!events.length && events.every(compareSplits);

  useEffect(() => {
    if (!isSplitSame || !isChartView || disableFormula) {
      onChangeLegendName('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSplitSame, isChartView, disableFormula]);

  return (
    <StyledLegendContainer>
      <span className="input-caption">Legend name:</span>
      <Input
        className="input"
        placeholder="User legend"
        value={enteredLegendName}
        onChange={(e) => onChangeLegendName(e.target.value)}
        disabled={!isSplitSame || !isChartView || disableFormula}
        maxLength={80}
      />
    </StyledLegendContainer>
  );
};

export default EventLegend;
